import axios from 'axios'
import { scanApiLinks, apiKeys } from './constants.ts';

const actions: Record<number, string> = {
  1: 'ethprice',
  56: 'bnbprice',
  11155111: 'ethprice',
  8453: 'ethprice',
  137: 'ethprice',
  10321: 'ethprice',
  97: 'bnbprice',
}

// ethPriceApiUrl[chainId]() returns Promise<number>
export const ethPriceApiUrl: Record<number, () => Promise<number>> =
  Object.fromEntries(
    Object.entries(actions).map(([chain, action]) => {
      const id = Number(chain)
      const base = scanApiLinks[id]
      const key = apiKeys[id]
      const url = `${base}?module=stats&action=${action}&apikey=${key}`
      return [
        id,
        // function to call the Scan API and extract data.result.ethusd
        async () => {
          const { data } = await axios.get(url)
          if (data.status !== '1') {
            throw new Error(`Scan API error: ${data.message}`)
          }
          return Number(data.result.ethusd)
        },
      ]
    })
  ) as Record<number, () => Promise<number>>
